import "./CallToAction.css";
import useAppData from "../../hooks/useAppData";

const CallToAction = () => {
	const {settings} = useAppData();
	const rawNumber = settings?.whatsapp_number;
	const cleanNumber = rawNumber?.replace(/\D/g, "");
	const url = cleanNumber ? `https://wa.me/${cleanNumber}` : "#";
	return (
		<div className="container">
			<div className="contact-section-div">
				<div className="contact-content">
					<h2>Need Help? We're Just a Message Away</h2>
					<h5>Our team is ready to assist you with fast, reliable answers.</h5>
				</div>
				<div className="contact-cta">
					<a
						href={url}
						target="_blank"
						rel="noreferrer"
					>
						<div className="green-circle"></div> Chat with us now
					</a>
				</div>
			</div>
		</div>
	);
};

export default CallToAction;
